import React from 'react';
import { Modal } from '../../components';

function Toaster(props) {
    return (
        <Modal
            isModalOpen={props.isModalOpen}
            className='bg-white p-4 rounded-md'
        >
            <section className='w-full h-full flex flex-col items-stretch justify-start'>
                <header className="border-b-2 text-sm flex items-center justify-between py-2 px-6">
                    <p className='font-semibold text-base text-red-600'>{props.header}</p>
                </header>
                <div className='p-4'>
                    <p className='mb-4 px-2 w-full'>
                        {props.body}
                    </p>
                </div>
                <div className='w-full'>
                    <button
                        className=' justify-center ml-80 py-2 px-4 border rounded-full bg-blue-60 text-white hover:bg-secondary-30 hover:border-secondary-30 focus:outline-none'    
                        onClick={props.onCancel}                    
                    >
                        Cancel
                    </button>                      
                    
                </div>
            </section>

        </Modal>  
    );
}

export default Toaster;
